var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrolleyIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91675 4.08325H10.9609C11.1239 4.08326 11.2851 4.11742 11.4341 4.18353C11.5831 4.24964 11.7165 4.34624 11.8259 4.46709C11.9353 4.58795 12.0181 4.73038 12.0691 4.88521C12.12 5.04003 12.138 5.20382 12.1217 5.366L11.7717 8.866C11.743 9.15388 11.6082 9.4208 11.3937 9.61493C11.1792 9.80907 10.9002 9.91657 10.6109 9.91659H5.04008C4.77027 9.91669 4.50877 9.82328 4.30009 9.65225C4.09141 9.48123 3.94846 9.24316 3.89558 8.97859L2.91675 4.08325Z",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33341 12.25H10.5001M2.91675 4.08333L2.44425 2.19158C2.41265 2.06544 2.3398 1.95347 2.23729 1.87347C2.13477 1.79346 2.00846 1.75 1.87841 1.75H1.16675L2.91675 4.08333ZM4.66675 12.25H5.83341H4.66675Z",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrolleyIco);
export default __webpack_public_path__ + "static/media/trolley-ico.da116de16118baec6e002a80c309fbbd.svg";
export { ForwardRef as ReactComponent };